import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection, APP_INITIALIZER } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { routes } from './app.routes';
import { HttpClient, provideHttpClient, withInterceptors  } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { jwtInterceptor } from './interceptor/jwt.interceptor';
import { errorInterceptor } from './interceptor/error.interceptor';
import { AuthService } from './service/auth.service';
import { firstValueFrom, of } from 'rxjs';
import { catchError } from 'rxjs/operators';


/**
 * Konfiguracija Angular aplikacije.
 * 
 * Ovdje se definiraju svi potrebni provideri:
 * - provideZoneChangeDetection: optimizacija detekcije promjena
 * - provideRouter: omogućuje korištenje definiranih ruta
 * - provideHttpClient: omogućuje HTTP komunikaciju
 * - provideAnimations: omogućuje animacije u aplikaciji
 */

const httpLoaderFactory: (http: HttpClient) => TranslateHttpLoader = (http: HttpClient) =>
    new TranslateHttpLoader(http, './i18n/', '.json');

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptors([jwtInterceptor, errorInterceptor])),
    provideAnimations(),
    importProvidersFrom([TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: httpLoaderFactory,
          deps: [HttpClient],
        }, defaultLanguage: 'hr',
      }),
    ]),

    // Ensure we attempt a silent refresh during app bootstrap so an in-memory access token
    // is restored from the HttpOnly refresh cookie before components render. Failures are
    // ignored so the app can continue unauthenticated.
    {
      provide: APP_INITIALIZER,
      useFactory: (authService: AuthService) => {
        return () => firstValueFrom(authService.refreshToken().pipe(catchError(() => of(null))));
      },
      deps: [AuthService],
      multi: true,
    }
    
  ],
};
